import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import intervalPlural from "i18next-intervalplural-postprocessor";
import ICU from "i18next-icu";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "../messages/en.json";
import sk from "../messages/sk.json";
import cs from "../messages/cs.json";
import de from "../messages/de.json";
import hu from "../messages/hu.json";
import pl from "../messages/pl.json";
import ro from "../messages/ro.json";
import it from "../messages/it.json";

const options = {

    order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    lookupFromPathIndex: 1,
    lookupFromSubdomainIndex: 0,
    caches: ['localStorage', 'cookie'],
    cookieMinutes: 10,
    cookieDomain: 'zooza.app',
    htmlTag: document.documentElement,
    cookieOptions: {path: '/', sameSite: 'strict'},
    convertToSpecifiedUnits: true,
    checkWhitelist: true,
    checkForSimilarInWhitelist: true,
    whitelist: ['en', 'sk', 'cs', 'de', 'ro', 'pl', 'hu', 'it'],
    nonExplicitWhitelist: false,
    load: 'languageOnly',
    preCaches: ['en', 'sk', 'cs', 'de', 'ro', 'pl', 'hu', 'it'],
    cacheUserLanguage: true,
    excludeCacheFor: ['cimode'],


}

// `<html lang>` was hardcoded to "en" in index.html and never updated. The
// detector's `htmlTag` option only READS the attribute to guess a language; it
// never writes it back. A wrong `lang` mis-hyphenates text, tells a screen
// reader the wrong pronunciation, and lets the browser offer to translate a
// page that is already in the reader's language.
function syncDocumentLanguage(lng: string) {
    if (lng && typeof document !== "undefined") {
        document.documentElement.setAttribute("lang", lng.split("-")[0]);
    }
}

i18n.on("languageChanged", syncDocumentLanguage);

i18n.on("initialized", function () {
    const supportedLanguages = ["en", "sk", "cs", "de", "ro", "pl", "hu", "it"];
    const lng = i18n.language;
   if(lng.split('-').length > 1) {
       const lang = lng.split('-')[0];
       if (supportedLanguages.includes(lang)) {
           i18n.changeLanguage(lang);
       }
   }
})
const preprocessTranslations = (translations:any) => {
    Object.keys(translations).forEach((key) => {
        if (typeof translations[key] === "string") {
            translations[key] = translations[key].replace(/\\n/g, "<br />");
        } else if (typeof translations[key] === "object") {
            preprocessTranslations(translations[key]); // Recursive for nested objects
        }
    });
};

// Preprocess all languages
Object.values({ sk, en, cs, de, hu, pl, ro, it }).forEach(preprocessTranslations);

    const initI18n = async () => {
        // @ts-expect-error - `options` is the LanguageDetector's own option
        // bag, which i18next's `init` signature does not model.
        await i18n.use(LanguageDetector).init(options);
        await i18n
            .use(ICU)
            .use(intervalPlural)
            .use(initReactI18next)
            .init({
                debug: false,
                fallbackLng: "en",
                supportedLngs: ["en", "sk", "cs", "de", "ro", "pl", "hu", "it"],
                returnEmptyString: false,
                lng: localStorage.getItem("i18nextLng") || "",
                interpolation: {
                    escapeValue: false,
                    format: (value, format) => {
                        if (typeof value === "string" && format === "breaklines") {
                            return value.split("\\n").join("<br />");
                        }
                        return value;
                    },
                },

                resources: {
                    sk: {
                        translation: sk,
                    },
                    en: {
                        translation: en,
                    },
                    cs: {
                        translation: cs,
                    },
                    de: {
                        translation: de,
                    },
                    hu:{
                        translation: hu,
                    },
                    pl:{
                        translation: pl,
                    },
                    ro:{
                        translation: ro,
                    },
                    it:{
                        translation: it,
                    }

                },
            })

    };

    // `languageChanged` does not fire for the language i18next boots with, so
    // stamp the initial one explicitly.
    initI18n().then(() => syncDocumentLanguage(i18n.language));

    export default i18n;
